/**
 * Static-translations for fi. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const fi = {
  'anon.heading_default': 'Jatka vieraana',
  'anon.try_again': 'Yritä uudelleen',
  'auth.back_to_login': 'Takaisin kirjautumiseen',
  'auth.check_email_message': 'Tarkista sähköpostisi — lähetimme vahvistuskoodin.',
  'auth.check_email_title': 'Tarkista sähköpostisi',
  'auth.confirm_email_title': 'Vahvista sähköpostisi',
  'auth.confirmation_code': 'Vahvistuskoodi',
  'auth.continue_with_apple': 'Jatka Applella',
  'auth.continue_with_facebook': 'Jatka Facebookilla',
  'auth.continue_with_github': 'Jatka GitHubilla',
  'auth.continue_with_google': 'Jatka Googlella',
  'auth.create_account': 'Luo tili',
  'auth.default_subtitle': 'Kirjaudu käyttääksesi kaikkia ominaisuuksia ja synkronoidaksesi tietosi.',
  'auth.email': 'Sähköpostiosoite',
  'auth.email_already_registered': 'Tämä sähköposti on jo rekisteröity. Kirjaudu alta salasanallasi tai tilillä, jolla rekisteröidyit.',
  'auth.email_exists': 'Tilillä tällä sähköpostilla on jo olemassa.',
  'auth.email_not_confirmed': 'Vahvista ensin sähköpostiosoitteesi.',
  'auth.forgot_password': 'Unohditko salasanan?',
  'auth.forgot_password_title': 'Unohditko salasanan?',
  'auth.forgot_subtitle': 'Syötä sähköpostiosoitteesi, niin lähetämme sinulle salasanan palautuslinkkin.',
  'auth.generic_error': 'Jokin meni pieleen',
  'auth.have_account': 'Onko sinulla tili?',
  'auth.hide_password': 'Piilota salasana',
  'auth.identity_already_linked': 'Tämä tili on jo rekisteröity. Kirjaudu sillä sisään alta.',
  'auth.invalid_credentials': 'Virheellinen sähköposti tai salasana',
  'auth.invalid_otp': 'Koodi on virheellinen tai vanhentunut.',
  'auth.last_used': 'Viimeksi käytetty · {email}',
  'auth.last_used_no_email': 'Viimeksi käytetty',
  'auth.link_purchase_subheading': 'Yhdistämme oston tiliisi, jotta käyttöoikeus säilyy.',
  'auth.log_in': 'Kirjaudu',
  'auth.log_in_link': 'Kirjaudu',
  'auth.login_continue_purchase': 'Kirjaudu jatkaaksesi ostoa',
  'auth.network_error': 'Verkkovirhe. Tarkista yhteys ja yritä uudelleen.',
  'auth.no_account': 'Eikö sinulla ole tiliä?',
  'auth.or': 'tai',
  'auth.password': 'Salasana',
  'auth.passwords_mismatch': 'Salasanat eivät täsmää',
  'auth.rate_limited': 'Liian monta pyyntöä. Yritä myöhemmin uudelleen.',
  'auth.repeat_password': 'Toista salasana',
  'auth.reset_link_valid': 'Linkki on voimassa 1 tunnin.',
  'auth.reset_password_title': 'Nollaa salasana',
  'auth.reset_sent_message': 'Jos sähköposti on olemassa, lähetimme palautuskoodin.',
  'auth.reset_sent_subtitle': 'Lähetimme salasanan palautuslinkin. Noudata sähköpostin ohjeita.',
  'auth.restore_purchases_heading': 'Palauta ostot',
  'auth.restore_purchases_subheading': 'Kirjaudu palauttaaksesi ostoksesi.',
  'auth.send_reset': 'Lähetä palautuslinkki',
  'auth.service_unavailable': 'Palvelu ei ole tilapäisesti käytettävissä. Yritä myöhemmin.',
  'auth.show_password': 'Näytä salasana',
  'auth.sign_out': 'Kirjaudu ulos',
  'auth.sign_up': 'Rekisteröidy',
  'auth.sign_up_link': 'Rekisteröidy',
  'auth.signed_in': 'Kirjautunut',
  'auth.signin_failed': 'Kirjautuminen epäonnistui',
  'auth.signup_failed': 'Rekisteröinti epäonnistui',
  'auth.verify': 'Vahvista',
  'auth.weak_password': 'Salasana on liian heikko.',
  'auth.welcome': 'Tervetuloa!',
  'auth.welcome_signup': 'Tervetuloa!',
  'cta.close': 'Sulje',
  'cta.continue': 'Jatka',
  'cta.get_lifetime_access': 'Hanki elinikäinen käyttöoikeus',
  'cta.get_plan_daily': 'Hanki päiväpaketti',
  'cta.get_plan_monthly': 'Hanki kuukausipaketti',
  'cta.get_plan_weekly': 'Hanki viikkopaketti',
  'cta.get_plan_yearly': 'Hanki vuosipaketti',
  'cta.start_trial': 'Aloita {days} päivän ilmainen kokeilu',
  'modal.close_aria': 'Sulje',
  'modal.continue': 'Jatka',
  'modal.error_generic': 'Jokin meni pieleen',
  'modal.loading': 'Ladataan…',
  'modal.purchase_restored_subtitle': 'Kaikki valmista — nauti!',
  'modal.purchase_restored_title': 'Tervetuloa takaisin',
  'modal.purchase_success_subtitle': 'Kaikki valmista — nauti!',
  'modal.purchase_success_title': 'Maksu vastaanotettu',
  'modal.verifying_subscription': 'Tarkistetaan tilausta…',
  'nav.back': '← Takaisin',
  'nav.back_aria': 'Takaisin',
  'offer.limited_time': 'Rajoitetun ajan tarjous',
  'payment.awaiting_title': 'Suorita maksu uudessa välilehdessä',
  'payment.checking': 'Tarkistetaan…',
  'payment.ive_paid': 'Olen maksanut',
  'payment.open_checkout_again': 'Avaa maksu uudelleen',
  'payment.open_checkout_button': 'Avaa maksu',
  'pricing.free_trial_days': '{days}-päivän ilmainen kokeilu',
  'pricing.included_per': 'Sisältyy per {interval}:',
  'pricing.interval.day': 'päivä',
  'pricing.interval.lifetime_short': 'elinikäinen',
  'pricing.interval.month': 'kuukausi',
  'pricing.interval.period': 'jakso',
  'pricing.interval.week': 'viikko',
  'pricing.interval.year': 'vuosi',
  'pricing.money_back': '30 päivän rahat-takaisin-takuu',
  'pricing.most_popular': 'Suosituin',
  'pricing.no_prices': 'Ei hintoja saatavilla.',
  'pricing.plan_label.daily': 'PÄIVITTÄINEN PAKETTI',
  'pricing.plan_label.lifetime': 'elinikäinen',
  'pricing.plan_label.monthly': 'kuukausitilaus',
  'pricing.plan_label.weekly': 'viikkotilaus',
  'pricing.plan_label.yearly': 'vuositilaus',
  'pricing.plans_aria': 'Paketit',
  'session.contact_support': 'Ota yhteyttä tukeen',
  'session.restore_purchases': 'Palauta ostot',
  'session.sign_out': 'Kirjaudu ulos',
  'session.signed_in_as_prefix': 'Kirjautunut nimellä',
  'session.signing_out': 'Kirjaudutaan ulos…',
  'support.attachments_label': 'Liitteet',
  'support.close_button': 'Sulje',
  'support.done_button': 'Valmis',
  'support.email_placeholder': 'Syötä sähköpostiosoitteesi',
  'support.heading': 'Tuki',
  'support.instruction': 'Täytä alla oleva lomake lähettääksesi tukipyynnön.',
  'support.invalid_email': 'Virheellinen sähköpostiosoite',
  'support.message_length': '1–5000 merkkiä',
  'support.message_placeholder': 'Syötä viestisi',
  'support.required': 'Pakollinen',
  'support.send_another': 'Lähetä uusi pyyntö',
  'support.send_button': 'Lähetä',
  'support.sending': 'Lähetetään…',
  'support.subject_length': '3–200 merkkiä',
  'support.subject_placeholder': 'Syötä aihe',
  'support.success_heading': 'Pyyntö lähetetty',
  'support.success_message_prefix': 'Olemme vastaanottaneet viestisi ja vastaamme osoitteeseen'
} as const;

export default fi;
